var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85723 14.5608L9.08379 15.3342C8.73223 15.6506 8.20488 15.6506 7.88848 15.3342L1.06816 8.47876C0.716601 8.16235 0.716601 7.63501 1.06816 7.3186L7.88848 0.463135C8.20488 0.146729 8.76738 0.146729 9.08379 0.463135L9.85723 1.23657C10.2088 1.58813 10.1736 2.11548 9.85723 2.46704L5.60332 6.47485H15.7283C16.1854 6.47485 16.5721 6.86157 16.5721 7.3186V8.4436C16.5721 8.93579 16.1854 9.28735 15.7283 9.28735H5.60332L9.85723 13.3303C10.1736 13.6819 10.2088 14.2092 9.85723 14.5608Z",
    fill: "#0F101E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.d3b74ca32656eee8c418e908b2c8c482.svg";
export { ForwardRef as ReactComponent };